/**
 * @class SessionStorage
 * @todo test when sessionStorage is not available
 */
export default class SessionStorage {
  #storage;

  constructor(storage = window.sessionStorage) {
    this.#storage = storage;
  }

  get(key) {
    try {
      return JSON.parse(this.#storage.getItem(key));
    } catch (error) {
      console.error(`Getting "${key}"`,error);
      return null;
    }
  }

  expose(key, target) {
    const value = this.get(key);
    if (value !== null) {
      target(value);
    }
  }

  set(key, value) {
    if (/* value === null || */value === undefined) {
      // TODO: hot reload time to times cause an errors with attempt to preserve undefined value
      this.remove(key);
      return;
    }
    try {
      this.#storage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(`Setting "${key}" cause`, error);
    }
  }

  remove(key) {
    try {
      this.#storage.removeItem(key);
    } catch (error) {
      console.error(error);
    }
  }
}
